import { z } from "zod";

import { chillnnNewPasswordZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

export const authResetPasswordInputZodSchema = z.object({
	password: chillnnNewPasswordZodSchema,
});

export type AuthResetPasswordInputType = z.infer<typeof authResetPasswordInputZodSchema>;
